export const xlat = {
    "HEADER_NOT_PROVIDED": "Interner Fehler: Autorisierungs-Header fehlt",
    "DEVICE_NOT_AUTHORIZED": "Interner Fehler: Gerät nicht mehr autorisiert",
    "BEARER_TOKEN_REQUIRED": "Interner Fehler: Eindeutige Kennung fehlt",
    "USER_EMAIL_ALREADY_EXISTS": "Email-Adresse bereits verwendet",
    "UNDELETABLE_USER": "Benutzer kann nicht gelöscht werden",
    "BUSINESS_NAME_ALREADY_EXISTS": "Geschäft mit diesem Namen existiert bereits",
    "BUSINESS_INSUFFICIENT_FUNDS": "Geschäft hat kein ausreichendes Guthaben",
    "DEVICE_ALREADY_ACTIVATED": "Gerät bereits aktiviert",
    "DEVICE_NOT_ACTIVATED": "Gerät noch nicht aktiviert",
    "UNDELETABLE_DEVICE": "Gerät kann nicht gelöscht werden",
    "REGISTRATION_EXPENDED": "Registrierungscode bereits eingesetzt",
    "CARD_INSUFFICIENT_FUNDS": "Karte hat kein ausreichendes Guthaben",
    "UNCREDITABLE_CARD": "Karte kann nicht aufgeladen werden",
    "UNDEBITABLE_CARD": "Karte kann nicht belastet werden",
    "UNLINKABLE_CARD": "Karte kann nicht gekoppelt werden",
    "CARD_ALREADY_LINKED": "Karte bereits gekoppelt",
    "CARD_ALREADY_UNLINKED": "Karte noch nicht gekoppelt",
    "TRANSACTION_ALREADY_CANCELLED": "Transaktion bereits storniert",
    "TRANSACTION_CANCELLATION_EXPIRED": "Zu spät für Storno; bitte umgekehrte Transaktion durchführen",
    "UNCANCELLABLE_TRANSACTION": "Transaktion kann nicht storniert werden",
    "OVERDRAFT_LIMIT_ALREADY_EXISTS": "Kreditlimite existiert bereits",
    "CARD_ATTACHMENT_ALREADY_EXISTS": "Kartenanhang existiert bereits",
    "CARD_ATTACHMENT_ALREADY_DELETED": "Kartenanhang bereits gelöscht",
    "INSUFFICIENT_PRIVILEGES": "Unzureichende Berechtigungen",
    "USER_NOT_FOUND": "Benutzer nicht bekannt",
    "USER_DELETED": "Benutzer gelöscht",
    "BUSINESS_NOT_FOUND": "Geschäft nicht bekannt",
    "DEVICE_NOT_FOUND": "Gerät nicht bekannt",
    "DEVICE_DELETED": "Gerät gelöscht",
    "REGISTRATION_NOT_FOUND": "Registrierungscode ungültig",
    "REGISTRATION_EXPIRED": "Registrierungscode abgelaufen",
    "CARD_NOT_FOUND": "Karte nicht gefunden",
    "TRANSACTION_NOT_FOUND": "Transaktion nicht bekannt",
    "OVERDRAFT_LIMIT_NOT_FOUND": "Kreditlimite nicht gesetzt",
    "CARD_ATTACHMENT_NOT_FOUND": "Kartenanhang nicht gesetzt",
    "INVALID_USER_EMAIL": "Emailadresse ungültig",
    "INVALID_USER_FIRST_NAME": "Vorname ungültig",
    "INVALID_USER_LAST_NAME": "Nachname ungültig",
    "INVALID_BUSINESS_NAME": "Geschäftsname ungültig",
    "INVALID_BUSINESS_LOGO_URL": "Logo-URL ungültig",
    "INVALID_DEVICE_NAME": "Gerätename ungültig",
    "INVALID_BUSINESS_CREDIT_TRANSACTION_AMOUNT": "Betrag muss zwischen CHF 0.00 und CHF 2500.00 liegen",
    "INVALID_CARD_CREDIT_TRANSACTION_AMOUNT": "Betrag muss zwischen CHF 0.00 und CHF 250.00 liegen",
    "INVALID_CARD_DEBIT_TRANSACTION_AMOUNT": "Betrag muss zwischen CHF 0.00 und CHF 250.00 liegen",
    "INVALID_BUSINESS_OVERDRAFT_LIMIT_AMOUNT": "Kreditlimite muss positiv sein",
    "INVALID_CARD_ATTACHMENT_TYPE": "Ungültiger Typ des Anhangs",
    "INVALID_CARD_ATTACHMENT_URL": "Ungültige URL des Anhangs",
    "INVALID_CARD_ATTACHMENT_VIDEO_URL": "Ungültige URL des Videos",
    "INVALID_CARD_ATTACHMENT_THUMBNAIL_URL": "Ungültige URL der Video-Vorschau",
    "INVALID_CARD_ATTACHMENT_EXPIRY": "Ungültige Zeitspanne für die automatische Löschung des Videos (1…52 Wochen)"
};
//# sourceMappingURL=index.js.map